import { Link, useLocation } from "react-router-dom";
import { Home, Users, BookOpen, Calendar, User } from "lucide-react";

const NAV_ITEMS = [
  { path: "/", label: "Home", icon: Home, exact: true },
  { path: "/collectives", label: "Collectives", icon: Users },
  { path: "/media", label: "Media", icon: BookOpen, altPaths: ["/videos"] },
  { path: "/live-events", label: "Events", icon: Calendar, altPaths: ["/events"] },
  { path: "/me", label: "Me", icon: User },
];

export default function BottomTabBar() {
  const location = useLocation();

  const isActive = (item) => {
    if (item.exact) return location.pathname === item.path;
    const paths = [item.path, ...(item.altPaths || [])];
    return paths.some((p) => location.pathname === p || location.pathname.startsWith(p + "/"));
  };

  // Hide on certain pages (e.g., admin, checkout)
  if (
    location.pathname.startsWith("/wa-ops-center") ||
    location.pathname.startsWith("/dashboard") ||
    location.pathname.startsWith("/checkout") ||
    location.pathname.startsWith("/p/")
  ) {
    return null;
  }

  return (
    <nav
      data-testid="bottom-tab-bar"
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-navy border-t border-gold/20 shadow-[0_-4px_24px_rgba(0,0,0,0.15)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="flex h-16">
        {NAV_ITEMS.map((item) => {
          const active = isActive(item);
          const Icon = item.icon;
          return (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`tab-${item.label.toLowerCase()}`}
              className={`flex-1 flex flex-col items-center justify-center relative transition-all duration-300 ${
                active ? "text-gold" : "text-bone/60 hover:text-bone"
              }`}
            >
              {active && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-[3px] bg-gold rounded-b-md" />
              )}
              <Icon
                className={`h-6 w-6 mb-1 transition-transform duration-300 ${
                  active ? "scale-110 drop-shadow-[0_0_8px_rgba(212,175,55,0.5)]" : "scale-100"
                }`}
                strokeWidth={active ? 2.5 : 2}
              />
              <span
                className={`text-[10px] leading-none font-heading tracking-wide uppercase ${
                  active ? "font-bold" : "font-medium"
                }`}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
